/**
 * Horizontal process tabs: one expanded panel at a time.
 */
(function () {
  const prefersReduced =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isMobile = () =>
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(max-width: 991px)').matches;

  function setActive(track, activeBtn) {
    const tabs = track.querySelectorAll('.process-tabs__tab');
    tabs.forEach((btn) => {
      const on = btn === activeBtn;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function bind(root) {
    const track = root.querySelector('.process-tabs__track');
    if (!track || track.dataset.processTabsBound === 'true') return;
    track.dataset.processTabsBound = 'true';

    const isMobileScroll = () => root.classList.contains('process-tabs--mobile-scroll') && isMobile();

    // Keep correct state when switching between mobile and desktop without refresh.
    function normalizeStateForViewport() {
      const tabs = Array.from(track.querySelectorAll('.process-tabs__tab'));
      if (!tabs.length) return;

      if (isMobileScroll()) {
        tabs.forEach((btn) => {
          btn.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
        });
        return;
      }

      // Desktop mode: ensure exactly one active tab.
      const currentlyActive = tabs.filter((btn) => btn.classList.contains('is-active'));
      const target = currentlyActive[0] || tabs[0];
      setActive(track, target);
    }

    normalizeStateForViewport();

    track.addEventListener('click', (e) => {
      const btn = e.target.closest('.process-tabs__tab');
      if (!btn || !track.contains(btn)) return;
      if (!isMobileScroll()) {
        if (btn.classList.contains('is-active')) return;
        setActive(track, btn);
      }

      // Mobile scroll mode: keep active tab in view.
      if (isMobileScroll()) {
        try {
          btn.scrollIntoView({
            behavior: prefersReduced ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        } catch (err) {
          // no-op (older browsers)
        }
      }
    });

    // Handle resize/orientation changes.
    window.addEventListener('resize', normalizeStateForViewport, { passive: true });
  }

  function init(scope) {
    const container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-process-tabs-root]').forEach(bind);
  }

  // Initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Shopify theme editor dynamic section lifecycle.
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });

  document.addEventListener('shopify:section:reorder', (event) => {
    init(event.target || document);
  });
})();
